export default __webpack_public_path__ + "static/media/blog-level-3.9c205fb9.svg";